{
  "register-personal-data-page": {
    "buttons": {
      "next": "Weiter",
      "to-login": "Zum Anmelden"
    },
    "text": {
      "title": "Registrierung",
      "subtitle": "Registrieren Sie Ihr neues Konto",
      "have-account-question": "Sie haben bereits ein Konto?",
      "personal-info": "Ihre persönlichen Daten",
      "personal-info-hint": "Geben Sie Ihre Daten ein"
    }
  }
}
